import 'twin.macro'

import FFLogo from 'assets/icons/ff-logo.svg?component'
import Step from 'components/UI/AppStep'
import { MenuToggle } from 'components/UI/Buttons/MenuButton'
import { useCycle } from 'framer-motion'
import { motion } from 'framer-motion'
import { useAppSelector } from 'hooks'
import { useTranslation } from 'react-i18next'
import { isLoggedInSelector } from 'redux/store/slices/authSlice'
import { getCurrentStepNumberSelector } from 'redux/store/slices/statusSlice'
import tw, { TwStyle } from 'twin.macro'
import { APP_STEPS } from 'utils/constants'

import Menu from '../Menu'

type MobileHeaderProps = {
  twStyle?: TwStyle
}

const MobileHeader = ({ twStyle }: MobileHeaderProps) => {
  // Tools
  const { t } = useTranslation()

  // State
  const [isOpen, toggleOpen] = useCycle(false, true)

  // Selectors
  const { isSuccess, title, step } = useAppSelector(getCurrentStepNumberSelector)
  const isLoggedIn = useAppSelector(isLoggedInSelector)

  return (
    <motion.div css={twStyle} tw='flex items-center' animate={isOpen ? 'open' : 'closed'}>
      <MenuToggle toggle={toggleOpen} twStyle={tw`mr-4`} />
      {!isSuccess && isLoggedIn ? (
        <Step step={step} stepsCount={APP_STEPS.length} currentStep={step}>
          {t(title)}
        </Step>
      ) : (
        <FFLogo tw='cursor-pointer h-8' />
      )}
      <Menu isOpen={isOpen} />
    </motion.div>
  )
}

export default MobileHeader
